import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Accessible breadcrumbs with structured-data friendly markup.
export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="container-page pt-6" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-[13px] text-muted-foreground">
        <li>
          <Link to="/" className="hover:text-teal transition-colors">Home</Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5 text-[#9AA6AE]" aria-hidden="true" />
            {item.path && i < items.length - 1 ? (
              <Link to={item.path} className="hover:text-teal transition-colors">{item.label}</Link>
            ) : (
              <span className="text-navy font-medium" aria-current="page">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
